import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
// import ReCAPTCHA from 'react-google-recaptcha'
import toast from 'react-hot-toast';
import {Button, Loader, FormField} from '../'
import { createContactUsMessage } from '../../actions/contactUs';
import { userValidateEmailAddress, userValidateFirstName, userValidateLastName, userValidateMessage } from '../validation/contact/contact'
import './contact.css'

const Contact = () => {
  const dispatch                                    = useDispatch();
  const [savingInfo, setSavingInfo]                 = useState(false);
  const [firstNameErrors, setFirstNameErrors]       = useState(null);
  const [lastNameErrors, setLastNameErrors]         = useState(null);
  const [emailAddressErrors, setEmailAddressErrors] = useState(null);
  const [messageErrors, setMessageErrors]           = useState(null);
  // const recaptchaRef                                = useRef();
  // const [captchaValue, setCaptchaValue]             = useState(null);
  const [isButtonDisabled, setIsButtonDisabled]     = useState(true);
  const [errorMessage, setErrorMessage]             = useState(null);

  const [postData, setPostData]          = useState({firstName: '', lastName: '', emailAddress: '', message: ''});
  const [isLoadingBtn, setIsLoadingBtn]  = useState({firstName: false, lastName: false, emailAddress: false, message: false });
  const [isValid, setIsValid]            = useState({firstName: false, lastName: false, emailAddress: false, message: false });

  const useDebounce = (value, delay ) => {
    const [debounced, setDebounced] = useState(value)

    useEffect(() =>{
      const handler = setTimeout(() => {
        setDebounced(value)
      }, delay);
      return () => clearTimeout(handler)
    }, [value, delay])

    return debounced
  }

  const debouncedPostData          = useDebounce(postData, 500) //postData

  const handleChange = (e) => {
    const { name, value } = e.target;
    setIsLoadingBtn((prevState) => ({ ...prevState, [name]: true }));
    setPostData((prevState) => ({ ...prevState, [name]: value }));
  }

  // const handleChangeCaptcha = (value) => {
  //   setCaptchaValue(value);
  // };

  useEffect(() => {
    const validateFirstName = () => {
      const { isValid, errors } = userValidateFirstName(debouncedPostData.firstName);
      setIsValid((prevState) => ({
        ...prevState,
        firstName: isValid,
      }));
      setIsLoadingBtn((prevState) => ({
        ...prevState,
        firstName: false,
      }));
      return errors;
    };

    const validateLastName = () => {
      const { isValid, errors } = userValidateLastName(debouncedPostData.lastName);
      setIsValid((prevState) => ({
        ...prevState,
        lastName: isValid,
      }));
      setIsLoadingBtn((prevState) => ({
        ...prevState,
        lastName: false,
      }));
      return errors;
    };
  
    const validateEmailAddress = () => {
      const { isValid, errors } = userValidateEmailAddress(debouncedPostData.emailAddress);
      setIsValid((prevState) => ({
        ...prevState,
        emailAddress: isValid,
      }));
      setIsLoadingBtn((prevState) => ({
        ...prevState,
        emailAddress: false,
      }));
      return errors;
    };

    const validateMessage = () => {
      const { isValid, errors } = userValidateMessage(debouncedPostData.message);
      setIsValid((prevState) => ({
        ...prevState,
        message: isValid,
      }));
      setIsLoadingBtn((prevState) => ({
        ...prevState,
        message: false,
      }));
      return errors;
    };
  
    const firstNameErrors      = validateFirstName();
    const lastNameErrors       = validateLastName();
    const emailAddressErrors   = validateEmailAddress();
    const messageErrors        = validateMessage()
    
    setFirstNameErrors(firstNameErrors);
    setLastNameErrors(lastNameErrors);
    setEmailAddressErrors(emailAddressErrors);
    setMessageErrors(messageErrors);

    const hasErrors = () => {
      // Check if any error exists in the form data
      if ( firstNameErrors.length > 0 || lastNameErrors.length > 0 || emailAddressErrors.length > 0 || messageErrors.length > 0 ) {
        return true;
      } else{
        return false;
      }
    };
    const hasFormErrors = hasErrors();
    setIsButtonDisabled(hasFormErrors);
  }, [debouncedPostData]);

  const handleSubmit = async(e) => {
    e.preventDefault();
    const returnConfirm = window.confirm('Are you sure you want to send a message?')
    if(returnConfirm){
      setSavingInfo(true);
      const response = await dispatch(createContactUsMessage(postData))
      try{
        if(response.success === true){
          toast.success("Message Sent")
          setErrorMessage(null);
          setPostData({firstName: '', lastName: '', emailAddress: '', message: ''})
          // if (recaptchaRef.current) {
          //   recaptchaRef.current.reset();
          // }
          // window.location.reload()
        }else if (response.data === 400){
          setErrorMessage(response.data.message);
        }
      }catch(error){
        setErrorMessage(error.data.message);
      }finally{
        setSavingInfo(false)
      }
    }
  }

  return (
    <>
        <section id='contact' className='contact-main-wrapper'>
        <h2>Contact Me</h2>
        <div className='contact-description'>Please send me a message and i will get back to you as soon as possible.</div>

        <form className='contact-reg-container' onSubmit={handleSubmit} autoComplete="off">
            <FormField inputType type="text" labelName="First Name" name="firstName" value={postData.firstName} handleChange={handleChange} isLoadingBtn={isLoadingBtn.firstName} isValid={isValid.firstName} errors={firstNameErrors || []} />
            
            <FormField inputType type="text" labelName="Last Name" name="lastName" value={postData.lastName} handleChange={handleChange} isLoadingBtn={isLoadingBtn.lastName} isValid={isValid.lastName} errors={lastNameErrors || []} />
    
            <FormField inputType type="text" labelName="Email Address" name="emailAddress" value={postData.emailAddress} handleChange={handleChange} isLoadingBtn={isLoadingBtn.emailAddress} isValid={isValid.emailAddress} errors={emailAddressErrors || []} />
    
            <FormField textareaType maxLength={1000} labelName="Message" name="message" value={postData.message} handleChange={handleChange} isLoadingBtn={isLoadingBtn.message} isValid={isValid.message} errors={messageErrors || []} />
    
            {/* <div className='contact-captcha'><ReCAPTCHA sitekey="6LdOKzwnAAAAAFbP4KMhcR-XyF8IFEKYkJ6g-IM-" onChange={handleChangeCaptcha}/></div> */}
            {/* <div className='contact-captcha'><ReCAPTCHA sitekey="" onChange={handleChangeCaptcha}/></div> */}
    
            <Button onClickButton buttonClickWrap={savingInfo ? `button-login-submitted` : `button-login-submit`} onClickName={savingInfo ? <>{<Loader />} Sending...</> : "Send"} isButtonDisabled={isButtonDisabled} buttonClasses={savingInfo ? ['button-disabled'] : (isButtonDisabled ? ['buttonDisabledClass'] : ['buttonEnabledClass'])} disabled={savingInfo} />

            {errorMessage && <p className='error-msg'>{errorMessage}</p>}
        </form>
        </section>
    </>
  )
}

export default Contact